module.exports = __webpack_public_path__ + "img/trade-img-8coin.bf8a7588.png";